/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Mode_EnableInputs */



/**
* | output |
* | --- |
* | "Start voice mode" |
*
* @param {Voice_Mode_EnableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_mode_enable = /** @type {((inputs?: Voice_Mode_EnableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Mode_EnableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachmodus starten")
	return /** @type {LocalizedString} */ ("Start voice mode")
});